import React from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { getPageContentContact } from '../../../../entities/PageContent'
import { PageSection } from '../../../../shared/ui/PageSection'
import cls from './ContactSection.module.scss'

const DEFAULT_WHATSAPP_ICON =
    'https://cdn-icons-png.flaticon.com/256/185/185988.png'
const DEFAULT_TELEGRAM_ICON =
    'https://cdn-icons-png.freepik.com/256/2111/2111646.png'

const ContactSection: React.FC = () => {
    const { t, i18n } = useTranslation()
    const contact = useSelector(getPageContentContact)
    const lang = i18n.language.split('-')[0]

    const title = contact
        ? lang === 'ru'
            ? contact.titleRu
            : contact.titleEn
        : t('contact.title')
    const phone = contact?.phone ?? '+996 555 309 509'
    const whatsappUrl = contact?.whatsappUrl ?? 'https://wa.me/996555309509'
    const whatsappLabel = contact?.whatsappLabel ?? 'WhatsApp'
    const telegramUrl = contact?.telegramUrl ?? 'https://t.me/vanlifekg'
    const telegramLabel = contact?.telegramLabel ?? 'Telegram'
    const whatsappIcon = DEFAULT_WHATSAPP_ICON
    const telegramIcon = DEFAULT_TELEGRAM_ICON

    return (
        <PageSection
            title={title}
            style={{ backgroundColor: 'var(--bg-muted)' }}
        >
            <div className={cls.links}>
                <a
                    href={whatsappUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className={`${cls.link} ${cls.whatsapp}`}
                    aria-label={whatsappLabel}
                >
                    <img
                        src={whatsappIcon}
                        alt=""
                        className={cls.icon}
                        loading="lazy"
                    />
                    {whatsappLabel}
                </a>
                <a
                    href={telegramUrl}
                    target="_blank"
                    rel="noopener noreferrer"
                    className={`${cls.link} ${cls.telegram}`}
                    aria-label={telegramLabel}
                >
                    <img
                        src={telegramIcon}
                        alt=""
                        className={cls.icon}
                        loading="lazy"
                    />
                    {telegramLabel}
                </a>
            </div>
            <p className={cls.phone}>{phone}</p>
        </PageSection>
    )
}

export default ContactSection
